import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  checkMonth: Array<Object> = [
    {
      number: 1,
      name: 'ม.ค.'
    },
    {
      number: 2,
      name: 'ก.พ.'
    },
    {
      number: 3,
      name: 'มี.ค.'
    },
    {
      number: 4,
      name: 'เม.ย.'
    },
    {
      number: 5,
      name: 'พ.ค.'
    },
    {
      number: 6,
      name: 'มิ.ย.'
    },
    {
      number: 7,
      name: 'ก.ค.'
    },
    {
      number: 8,
      name: 'ส.ค.'
    },
    {
      number: 9,
      name: 'ก.ย.'
    },
    {
      number: 10,
      name: 'ต.ค.'
    },
    {
      number: 11,
      name: 'พ.ย.'
    },
    {
      number: 12,
      name: 'ธ.ค.'
    }
  ];

  checkMonthFullTh: Array<Object> = [
    {
      number: 1,
      name: 'มกราคม'
    },
    {
      number: 2,
      name: 'กุมภาพันธ์'
    },
    {
      number: 3,
      name: 'มีนาคม'
    },
    {
      number: 4,
      name: 'เมษายน'
    },
    {
      number: 5,
      name: 'พฤษภาคม'
    },
    {
      number: 6,
      name: 'มิถุนายน'
    },
    {
      number: 7,
      name: 'กรกฎาคม'
    },
    {
      number: 8,
      name: 'สิงหาคม'
    },
    {
      number: 9,
      name: 'กันยายน'
    },
    {
      number: 10,
      name: 'ตุลาคม'
    },
    {
      number: 11,
      name: 'พฤศจิกายน'
    },
    {
      number: 12,
      name: 'ธันวาคม'
    }
  ];

  checkMonth_en: Array<Object> = [
    {
      number: 1,
      name: 'Jan'
    },
    {
      number: 2,
      name: 'Feb'
    },
    {
      number: 3,
      name: 'Mar'
    },
    {
      number: 4,
      name: 'Apr'
    },
    {
      number: 5,
      name: 'May'
    },
    {
      number: 6,
      name: 'Jun'
    },
    {
      number: 7,
      name: 'Jul'
    },
    {
      number: 8,
      name: 'Aug'
    },
    {
      number: 9,
      name: 'Sep'
    },
    {
      number: 10,
      name: 'Oct'
    },
    {
      number: 11,
      name: 'Nov'
    },
    {
      number: 12,
      name: 'Dec'
    }
  ];

  checkMonthFullEn: Array<Object> = [
    {
      number: 1,
      name: 'January'
    },
    {
      number: 2,
      name: 'February'
    },
    {
      number: 3,
      name: 'March'
    },
    {
      number: 4,
      name: 'April'
    },
    {
      number: 5,
      name: 'May'
    },
    {
      number: 6,
      name: 'June'
    },
    {
      number: 7,
      name: 'July'
    },
    {
      number: 8,
      name: 'August'
    },
    {
      number: 9,
      name: 'September'
    },
    {
      number: 10,
      name: 'October'
    },
    {
      number: 11,
      name: 'November'
    },
    {
      number: 12,
      name: 'December'
    }
  ];


  constructor() { }

  changeFormatDate(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return day + ' ' + monthTh['name'] + ' ' + year;
    }
  }

  changeFormatDate_2(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() ;
      const monthTh = this.checkMonth_en.filter(m => m['number'] === month)[0];
      return day + ' ' + monthTh['name'] + ' ' + year;
    }
  }

  changeFormatDateFullTh(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonthFullTh.filter(m => m['number'] === month)[0];
      return day + ' ' + monthTh['name'] + ' ' + year;
    }
  }

  changeFormatDateFullEn(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear();
      const monthTh = this.checkMonthFullEn.filter(m => m['number'] === month)[0];
      return monthTh['name'] + ' ' + day + ', ' + year;
    }
  }
}

